import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import CategoriesData from "../../models/CategoriesData";
import Title from "../common/TitleComponent";
import { Link } from "react-router";

import { motion } from "framer-motion";
import { fadeIn } from "../animation/Variants";
import TreatmentsData from "../../models/TreatmentsData";

const TreatmentsSlider = ({ Category }) => {
  const settings = {
    autoplay: true,
    autoplaySpeed: 3500,
    cssEase: "linear",
    dots: false,
    infinite: true,
    initialSlide: 0,
    slidesToShow: 4,
    slidesToScroll: 1,
    // speed: 1500,
    speed: 1000,
    swipeToSlide: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          dots: false,
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          dots: false,
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          dots: false,
          slidesToShow: 1,
        },
      },
    ],
  };
  return (
    <>
      <div className="w-full">
        <Title
          Title={`Check out similar treatments`}
          Subtitle={`Our treatments under the ${Category} category`}
        />

        <Slider {...settings}>
          {TreatmentsData.filter((item) => item.categoryName == Category).map((item) => (
            <div className="w-full" key={item.id}>
              <div className="featured-imagebox featured-imagebox-service style1">
                <div className="featured-thumbnail">
                  <img
                    className="w-full h-52"
                    src={item.src}
                    alt={item.alt}
                  />
                </div>
                <Link to={`/Treatment/${item.title}`} onClick={window.scroll(0, 0)}>
                  <div className="featured-content slick_title ">
                    <div className="featured-title">
                      <h3 className="title_DMSerifText-Regular">
                        {item.title}
                      </h3>
                    </div>
                  </div>
                  <div className="px-3 mb-3 description_AlegreyaSans-Light">
                    <p>Duration: {item.duration} </p>
                    <p>Price: {item.price}/= </p>
                  </div>
                </Link>
              </div>
            </div>
          ))}
        </Slider>

      </div>
    </>
  );
};

export default TreatmentsSlider;
